import React, { useEffect } from "react";
import { PageHeaderUi } from "../../../../ui/PageHeaderUi";
import { ButtonUi } from "../../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../../types/typesConstants";
import { Button, Col, Dropdown, Row, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  get_excel_consolidacionestela,
  get_excel_programacionestintoreria,
  programacionTintoreriaStartLoad,
  showFormProgramacionTintoreria,
} from "../../../../../actions/produccion";
import { ProgramacionTintoreriaTable } from "./ProgramacionTintoreriaTable";
import { ProgramacionTintoreriaScreen } from "./ProgramacionTintoreriaScreen";
import { ConsolidadoTelaScreen } from "../../consolidado/ConsolidadoTelaScreen";
import { ProgramacionTintoreriaSearchTable } from "./ProgramacionTintoreriaSearchTable";
import { DownOutlined, FileDoneOutlined } from "@ant-design/icons";
import { messageError } from "../../../../../helpers/messageConfig";
import {
  open_file,
  parseDateFormatBackEnd,
} from "../../../../../helpers/utils";
import dayjs from "dayjs";
import { ExcelIcon } from "../../../../ui";
const keys_reportes = {
  xls_programaciones: "P. Tintoreria",
  xls_consolidaciones: "Consolidado Tela",
};
const items_reportes = [
  {
    key: keys_reportes.xls_programaciones,
    label: keys_reportes.xls_programaciones,
    icon: <ExcelIcon />,
  },
  {
    key: keys_reportes.xls_consolidaciones,
    label: keys_reportes.xls_consolidaciones,
    icon: <ExcelIcon />,
  },
];
const ProgramacionTintoteriaListScreen = () => {
  const dispatch = useDispatch();
  const { programacionesTintoreria, loading, paginator } = useSelector(
    (state) => state.produccion,
  );
  const handleNuevo = () => {
    dispatch(showFormProgramacionTintoreria());
  };
  const handleReporteExcel = async () => {
    if (programacionesTintoreria?.length > 0) {
      const keys_programaciones = programacionesTintoreria
        ?.map((item) => item?.id)
        .join(",");
      const file =
        await get_excel_programacionestintoreria(keys_programaciones);
      let name_file = "ProgramacionesTintoreria.xlsx";
      open_file(file, name_file, file?.type);
    } else messageError("No existe información para imprimir");
  };
  const handleRptXlsConsolidaciones = async () => {
    if (programacionesTintoreria?.length > 0) {
      const keys_programaciones = programacionesTintoreria
        ?.map((item) => item?.id)
        .join(",");
      const file = await get_excel_consolidacionestela(keys_programaciones);
      let name_file = "ConsolidacionesTela.xlsx";
      open_file(file, name_file, file?.type);
    } else messageError("No existe información para imprimir");
  };
  const handleClickReportes = (value) => {
    if (value?.key === keys_reportes.xls_programaciones) {
      handleReporteExcel();
    } else if (value?.key === keys_reportes.xls_consolidaciones) {
      handleRptXlsConsolidaciones();
    }
  };
  return (
    <PageHeaderUi
      title="Programación de Tintoreria"
      subTitle="Listado"
      extra={[
        <Space key="opts" wrap>
          <Dropdown
            menu={{
              items: items_reportes,
              onClick: handleClickReportes,
            }}
          >
            <Button
              onClick={(e) => e.preventDefault()}
              color="cyan"
              variant="outlined"
            >
              <Space>
                <FileDoneOutlined />
                Reportes
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
          <ButtonUi
            key="nuevo"
            typeUi={TipoButtonConstants.Nuevo}
            onClick={handleNuevo}
          />
          ,
        </Space>,
      ]}
    >
      <div style={{ overflow: "hidden" }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <ProgramacionTintoreriaSearchTable />
          </Col>
        </Row>
        <Row>
          <Col sm={32} md={32} xl={24}>
            <ProgramacionTintoreriaTable
              data={programacionesTintoreria}
              loading={loading}
              paginator={paginator}
            />
          </Col>
        </Row>
      </div>
    </PageHeaderUi>
  );
};

export const ProgramacionTintoreriaList = () => {
  const { visibleFormProgramacionTintoreria, visibleFormConsolidadoTela } =
    useSelector((state) => state.produccion);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      programacionTintoreriaStartLoad({
        fechainicio_after: parseDateFormatBackEnd(dayjs()),
        fechainicio_before: parseDateFormatBackEnd(dayjs()),
      }),
    );
  }, []);
  if (visibleFormProgramacionTintoreria) {
    return <ProgramacionTintoreriaScreen />;
  } else if (visibleFormConsolidadoTela) {
    return <ConsolidadoTelaScreen />;
  } else {
    return <ProgramacionTintoteriaListScreen />;
  }
};
export default ProgramacionTintoreriaList;
